function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

// APP的方法请在这里定义
// 不要改原有的方法，因为要兼容旧的APP
// 加新的方法只能在新的地方调用，不要改原来的调用
// 不要怀疑旧的方法的名字和其功能是否对得上，由于历史原因，有些方法的功能已经不限于一开始设计的功能
// 一定要确保兼容性
// 一定要同时定义 iOS 和 Android
// sdk 不会对参数做特殊处理（除了Android，会自动将传入的参数转成字符串），一定要和APP端确定好类型、处理好再传进来
var ACTIONS = {
  /** 打开一个新的页面 */
  OPEN: {
    iOS: {
      // 以前有个"redirectCurriculumDetail"，其实际作用是一样的，只不过这个方法的作用已经不只是打开课程详情页面，而是可以打开任意的链接，所以换了个语义上更合理的名字
      method: "redirectToOtherWebView",
      resolveArguments: function resolveArguments(args) {
        return args.url;
      }
    },
    Android: {
      method: "CurriculumDetail",
      resolveArguments: function resolveArguments(args) {
        return [args.url];
      }
    }
  },

  /** 配置分享1 */
  CONFIG_SHARE: {
    iOS: {
      method: "getShareInfo",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "getShareInfo",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(args)];
      }
    }
  },

  /** 配置分享2（个别营销页面需要） */
  CONFIG_SHARE_GROUP: {
    iOS: {
      method: "shareMyGroup",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "ShareCollage",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(args)];
      }
    }
  },

  /** 跳转到选课中心 */
  NAV_TO_CHOOSE_COURSE: {
    iOS: "redirectElective",
    Android: "ContinueBuyCurriculum"
  },

  /** 更新购物车数字提醒 */
  UPDATE_SHOPPING_CART_COUNT: {
    iOS: {
      method: "updateShoppingCartCount",
      resolveArguments: function resolveArguments(args) {
        return args.count;
      }
    },
    Android: {
      method: "updateShoppingCartCount",
      resolveArguments: function resolveArguments(args) {
        return [args.count + ""];
      }
    }
  },

  /** 登录 */
  LOGIN: {
    iOS: {
      method: "redirectLogin",
      resolveArguments: function resolveArguments(args) {
        return args.redirect_url;
      }
    },
    Android: {
      method: "Login",
      resolveArguments: function resolveArguments(args) {
        return [args.redirect_url];
      }
    }
  },

  /** 滑块验证 */
  GET_SLIDE_DATA: {
    iOS: {
      method: "getSlideData",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "getSlideData",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(args)];
      }
    }
  },

  /** 跳转苹果支付 */
  APPLE_PAY: {
    iOS: {
      method: "redirectApplePay",
      resolveArguments: function resolveArguments(args) {
        return args.isPriceEnough;
      }
    } // Android没有

  },

  /** 分享图片（个别营销页面需要） */
  SHARE_IMAGE: {
    iOS: {
      method: "getShareImage",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "getShareImage",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(args)];
      }
    }
  },

  /** 活动信息（转介绍） */
  ACTIVITY_INFO: {
    iOS: {
      method: "getActivityInfo",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "getActivityInfo",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(args)];
      }
    }
  },

  /** 跳转回看页面 */
  NAV_TO_PLAYBACK: {
    iOS: {
      method: "redirectPlayBack",
      resolveArguments: function resolveArguments(args) {
        return args.lesson_id;
      }
    },
    Android: {
      method: "SeePlayBack",
      resolveArguments: function resolveArguments(args) {
        return [args.lesson_id];
      }
    }
  },

  /** 跳到课程详情 */
  NAV_TO_COURSE_DETAIL: {
    iOS: {
      method: "redirectCurriculumDetailNative",
      resolveArguments: function resolveArguments(args) {
        return JSON.stringify(args);
      }
    },
    Android: {
      method: "CurriculumDetailNative",
      resolveArguments: function resolveArguments(args) {
        return [args.curriculumId, args.subjectId];
      }
    }
  },

  /** 设置购物车显示/隐藏 */
  SHOPPING_CART_VISIBLE: {
    iOS: {
      method: "isShowShoppingCart",
      resolveArguments: function resolveArguments(args) {
        return !!args.visible;
      }
    },
    Android: {
      method: "isShowShoppingCart",
      resolveArguments: function resolveArguments(args) {
        return [JSON.stringify(!!args.visible)];
      }
    }
  },

  /** 跳转到原生的“我的” */
  NAV_TO_MY_CENTER: {
    iOS: "redirectMyController",
    Android: "UserCenter"
  },

  /** 打电话 */
  PHONE_CALL: {
    iOS: {
      method: "callPhone",
      resolveArguments: function resolveArguments(args) {
        return args.phone;
      }
    },
    Android: {
      method: "callPhone",
      resolveArguments: function resolveArguments(args) {
        return [args.phone];
      }
    }
  },

  /** 跳转原生的直播间 */
  NAV_TO_LIVEROOM: {
    iOS: {
      method: "redirectLiveroom",
      resolveArguments: function resolveArguments(args) {
        return args.lesson_id;
      }
    },
    Android: {
      method: "Live",
      resolveArguments: function resolveArguments(args) {
        return [args.lesson_id];
      }
    }
  },

  /** 跳转到我的课程 */
  NAV_TO_MY_CURRICULUM: {
    iOS: "redirectMyCurriculum",
    Android: "MyCurriculumList"
  },

  /** 支付成功 */
  NAV_TO_PAY_SUCCESS: {
    iOS: "redirectApplePaySuccess",
    Android: "FinishBuyCurriculum"
  },

  /** 打开微信 */
  GOTO_WECHAT: {
    iOS: "redirectWechatNative",
    Android: "redirectWechatNative"
  },

  /** 绑定微信(调起微信授权) */
  WECHAT_AUTHORIZED: {
    iOS: "weChatAuthorized",
    Android: "weChatAuthorized"
  },

  /** 唤起微信授权（2021暑假裂变调起微信授权） */
  WECHAT_AUTH_CODE: {
    iOS: {
      method: "getWechatAuthCode",
      resolveArguments: function resolveArguments(args) {
        return args.url;
      }
    },
    Android: {
      method: "getWechatAuthCode",
      resolveArguments: function resolveArguments(args) {
        return [args.url];
      }
    }
  },

  /**
   * 以下为外呼 app 相关
   * 仅限外呼 app 使用
   */

  /* 外呼登录并上线 */
  OUTBOUND_APP_LOGIN: {
    Android: "login"
  },

  /* 离线并退出登录 */
  OUTBOUND_APP_LOGOUT: {
    Android: "logout"
  },

  /* 拨打电话 */
  OUTBOUND_APP_CALLOUT: {
    Android: "callout"
  },

  /* 挂断 */
  OUTBOUND_APP_HANGUP: {
    Android: "hangup"
  },

  /** 外呼 app 更新 */
  OUTBOUND_APP_UPDATE: {
    Android: "updateApp"
  },

  /** 外呼 app 获取版本号 */
  OUTBOUND_APP_VERSION: {
    Android: "getAppVersion"
  }
};

/**
 * @todo 整合到 xiao-utils 里面
 * 获取一个对象的深度属性值
 * @param {object} obj
 * @param {string[]} props
 * @return {object}
 */

function deepGet(obj, props) {
  if (obj === null || typeof obj === 'undefined') {
    return obj;
  }

  if (props.length === 0) {
    return obj;
  }

  var objValue = obj;

  for (var i = 0; i < props.length; ++i) {
    objValue = objValue[props[i]];

    if (objValue === null || typeof objValue === 'undefined') {
      return void 0;
    }
  }

  return objValue;
}

var supportiOSWebview = deepGet(window, ["webkit", "messageHandlers"]);
var supportAndroidWebview = deepGet(window, ["Callback", "redirect"]);
var userAgent = navigator.userAgent.toLowerCase();
var isiosWebview = /xiaoioswebview/.test(userAgent);
var isAndroidWebview = /(xiaoandroidwebview|xhwxsipandroid)/.test(userAgent);

function try_iOSCallbackFn(actionName, body) {
  if (!window.webkit.messageHandlers[actionName]) {
    console.error("iOS APP\u65B9\u6CD5\u672A\u5B9A\u4E49: ".concat(actionName));
    return false;
  }

  try {
    body = body || "";
    window.webkit.messageHandlers[actionName].postMessage({
      body: body
    });
  } catch (err) {
    console.error('iOS APP方法调用失败', actionName, body, err);
  }
}

function tryAndroidCallbackFn(actionName, args) {
  try {
    args = args || []; // supportAndroidWebview(actionName, args)
    // 不要这样调用，这样调用会报错，只能 Callback.redirect 直接调用
    // Java bridge method can't be invoked on a non-injected object

    window.Callback.redirect(actionName, args);
  } catch (err) {
    console.error('Android APP方法调用失败', actionName, args, err);
  }
}
/**
 * 调用 APP 方法
 * @param {{iOS: string, Android: string}} action 
 * @param {*} args 
 */


function dispatch(action, args) {
  if (!(isiosWebview && supportiOSWebview) && !(isAndroidWebview && supportAndroidWebview)) {
    console.warn('当前环境不支持使用app-sdk');
    return false;
  }

  if (!action) {
    console.error("action\u4E0D\u80FD\u4E3A\u7A7A");
    return false;
  }

  var platform = isiosWebview ? 'iOS' : 'Android';
  var webviewCallbackFn = action[platform];

  if (!webviewCallbackFn) {
    console.error("".concat(platform, "\u65B9\u6CD5\u672A\u5B9A\u4E49: ").concat(action));
    return false;
  }

  if (_typeof(webviewCallbackFn) === 'object') {
    if (typeof webviewCallbackFn.resolveArguments === 'function') {
      args = webviewCallbackFn.resolveArguments(args);
    }

    webviewCallbackFn = webviewCallbackFn.method;

    if (!webviewCallbackFn) {
      console.error("".concat(platform, "\u65B9\u6CD5\u672A\u5B9A\u4E49: `").concat(action, "`"));
      return false;
    }
  }

  return (isiosWebview ? try_iOSCallbackFn : tryAndroidCallbackFn)(webviewCallbackFn, args);
}

var index = {
  ACTIONS: ACTIONS,
  dispatch: dispatch
};

export default index;
